import React from "react";
import {Box, ListItemButton, ListItemIcon, ListItemText} from "@mui/material";
import {UI, rgba} from "../../uiTokens";

/**
 * A selectable row used by both edit panels — the node's tab list and the
 * form's node list.
 *
 * - `icon`               optional leading icon element
 * - `primary`/`secondary` texts
 * - `active`             selected look (accent pill)
 * - `trailing`           optional trailing element (e.g. a drag handle)
 * - `capitalizeSecondary` title-case the secondary line (for machine strings)
 * - `className`/`onDragOver` forwarded to the row (drag-reorder support)
 */
export const EditMenuRow = ({
                                icon,
                                primary,
                                secondary,
                                active = false,
                                onClick,
                                trailing = null,
                                capitalizeSecondary = false,
                                className,
                                onDragOver,
                            }) => (
    <ListItemButton
        disableRipple
        className={className}
        onClick={onClick}
        onDragOver={onDragOver}
        sx={{
            gap: 0.25,
            px: 1,
            py: 0.6,
            my: 0.2,
            borderRadius: "8px",
            alignItems: "flex-start",
            backgroundColor: active ? rgba(UI.accent, 0.12) : "transparent",
            transition: "background-color .12s ease",
            "&:hover": {backgroundColor: rgba(UI.accent, active ? 0.16 : 0.08)},
            "&:hover .edit-row-trailing": {opacity: 1},
        }}
    >
        {icon && (
            <ListItemIcon sx={{minWidth: 30, mt: 0.25, color: active ? UI.accent : UI.muted}}>
                {icon}
            </ListItemIcon>
        )}
        <ListItemText
            primary={primary}
            secondary={secondary}
            primaryTypographyProps={{
                noWrap: true,
                fontSize: 13,
                fontWeight: active ? 700 : 600,
                color: active ? UI.accent : UI.ink,
            }}
            secondaryTypographyProps={{
                fontSize: 11,
                color: UI.muted,
                sx: capitalizeSecondary ? {textTransform: "capitalize"} : undefined,
            }}
        />
        {trailing && (
            <Box
                className="edit-row-trailing"
                sx={{display: "flex", alignItems: "center", ml: 0.5, mt: 0.25, opacity: 0.55, transition: "opacity .12s ease"}}
            >
                {trailing}
            </Box>
        )}
    </ListItemButton>
);
